import { View } from 'react-native';
import styled from 'styled-components/native';

export const TabsWrapper = styled(View)`
    width: 100%;
`;
